import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function ReparerPlutot() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Réparer plutôt que remplacer
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Avant de remplacer un moteur Somfy, nous vérifions systématiquement la cause exacte de la panne. Un volet qui ne répond plus peut être victime d'une télécommande io désynchronisée, d'un récepteur RTS en perte de mémoire après une coupure de courant, ou d'un condensateur usé qui empêche le démarrage. Ces trois cas représentent plus de la moitié des déplacements que nous effectuons à Strasbourg. Le remplacement du moteur n'est pas nécessaire : la réparation prend vingt minutes et coûte nettement moins cher.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              Nous n'effectuons jamais de remplacement sans un diagnostic préalable documenté. Notre technicien teste le moteur en direct, vérifie la tension aux bornes, contrôle la réception radio et inspecte les fins de course. Si le diagnostic confirme une usure irréversible du moteur tubulaire, nous vous présentons un devis avec le choix du nouveau moteur. Si une réparation suffit, nous la réalisons sur place et vous laissez le volet fonctionnel en moins d'une heure.
            </p>
            <div className="bg-[#143A66] rounded-xl p-6 md:p-8 text-white">
              <h3 className="text-lg font-bold mb-2">Diagnostic gratuit</h3>
              <p className="text-white/80 text-sm leading-relaxed mb-5">
                Nous inspectons votre moteur Somfy sur place et vous proposons la solution la plus adaptée. Pas de remplacement inutile.
              </p>
              <a
                href="tel:0374473240"
                className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-3 rounded-lg font-semibold text-sm hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
              >
                <i className="ri-phone-line text-base"></i>
                Appeler le 03 74 47 32 40
              </a>
            </div>
          </div>
          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder
              src="https://readdy.ai/api/search-image?query=Professional%20technician%20using%20a%20multimeter%20to%20test%20a%20Somfy%20roller%20shutter%20motor%20before%20deciding%20on%20repair%20or%20replacement%20in%20a%20clean%20workshop%20environment%20bright%20lighting%20warm%20neutral%20tones%20professional%20service%20photography%20detailed%20close%20up&width=700&height=520&seq=msf-diag&orientation=landscape"
              alt="Diagnostic précis d'un moteur Somfy avant remplacement à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}